export default {
  SET_WHITELABEL_CONFIG(state, data) {
    state.whitelabelConfig = data ? data : undefined
  },
  SET_IS_WHITELABEL_CONFIG_FRESH(state, value) {
    state.isWhitelabelConfigFresh = value
  },
  RESET_TO_DEFAULT(state) {
    state.isWhitelabelConfigFresh = false
    state.whitelabelConfig = undefined
  },
}
